import { pb } from '@q6cyber/proto2es';
import { cloneDeep } from 'lodash';

import { FormControl, FormGroup } from '@angular/forms';

export const DEFAULT_PHYSICAL_ADDRESS: pb.common.PhysicalAddress =
  new pb.common.PhysicalAddress().toJson({
    emitDefaultValues: true,
  }) as unknown as pb.common.PhysicalAddress;

export const physicalAddressForm = (
  data = cloneDeep(DEFAULT_PHYSICAL_ADDRESS)
) => {
  const form = new FormGroup({
    street: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    postal_code: new FormControl(''),
    country: new FormControl(''),
    raw: new FormControl(''),
    coords: new FormGroup({
      lat: new FormControl(null as number | null),
      lon: new FormControl(null as number | null),
    }),
  });
  form.patchValue(data as any);

  return form;
};

export type PhysicalAddressFormGroup = ReturnType<typeof physicalAddressForm>;
